import { render } from "./LimitExceededModal.vue?vue&type=template&id=87d7e7f2&scoped=true"
import script from "./LimitExceededModal.vue?vue&type=script&lang=js"
export * from "./LimitExceededModal.vue?vue&type=script&lang=js"

import "./LimitExceededModal.vue?vue&type=style&index=0&id=87d7e7f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87d7e7f2"]])

export default __exports__